module.exports = __webpack_public_path__ + "img/horizontal_4_7_9005.d7749182.png";